import React, {useContext, useEffect} from 'react';
import InfoGlobalBaseView from './InfoGlobalBaseView';
import {MadricContext} from '../../../Context/MadricContext';

/**
 *  InfoGlobalBase
 * @return {JSX}
 */
function InfoGlobalBase() {

  const {whatToShowGlobal, setWhatToShowGlobal, setActiveLink} = useContext(MadricContext);

  useEffect(() => {
  setActiveLink('historique')
  }, []);


  return (
    <div>
      <InfoGlobalBaseView 
       whatToShowGlobal={whatToShowGlobal}
       setWhatToShowGlobal={setWhatToShowGlobal}
      />
    </div>
  );
} 

export default InfoGlobalBase;
